import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import LuminaireDetail from '../../components/light/LuminaireDetail';
import { createLuminaireItem } from '../../redux/luminaire/luminaire_actions';

class LuminaireCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.luminaireDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newLuminaireItem = this.luminaireDetail.getWrappedInstance().getWrappedInstance().getLuminaireData();
    this.props.createLuminaireItem(newLuminaireItem);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create luminaire')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LuminaireDetail
            ref={ref => (this.luminaireDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-luminaire-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? 'Creating...' : 'Create'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const luminaireState = state.lighting.luminaire;
  return {
    errorMessage: luminaireState.errorMessage,
    isCreating: luminaireState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createLuminaireItem: luminaire =>
    dispatch(
      createLuminaireItem(
        luminaire.name,
        luminaire.brand_id,
        luminaire.type_id,
        luminaire.power_required,
        luminaire.description || '',
        luminaire.image,
        luminaire.cfp_value,
        luminaire.cfp_unit,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LuminaireCreateModal),
);


// WEBPACK FOOTER //
// ./src/modal/luminaire/LuminaireCreateModal.js